import React from "react";
import "./Qr.css";

const Qr = () => {
  return <div className="qr-body"></div>;
};

export default Qr;
